var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_layout d-flex flex-row gradient_background"},[_c('div',{staticClass:"side_bar desktop"},[_vm._t("page_side_bar")],2),_c('div',{staticClass:"content flex-grow-1"},[_vm._t("page_content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }